import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { addCustomNotification } from 'api/auth.api';
import { addGeneralInformation } from 'api/auth.api';

export const useAddGeneralInformation = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: addGeneralInformation,

    onSuccess: (res) => {
      toast({
        title: 'General Information created',
        description: res?.data?.message || 'Created successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to create general information',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
